<template>
	<div class="ion-page" main>
			<!-- <nav-bar :UserTypeName="EstamosEn()" /> -->
      <nav-bar :userTypeName="EstamosEn()" headerName="Nueva Solicitud"/>
      <ion-content>
        <form name="myForm" onsubmit="showDataAlert(event)">
          <ion-list lines="full" class="ion-no-margin ion-no-padding">
          
            <ion-item>
              <ion-label position="floating"> Usuario que Solicita </ion-label>
              <ion-input name="UsrSol"  :value="userInfo.name" ></ion-input>
            </ion-item>

            <ion-item v-if="UserType == 1">
              <ion-label position="floating"> Cliente que Solicita </ion-label>
              <ion-input name="cliente" ></ion-input>
            </ion-item>

            <!-- Departamento  @ionChange="console.log("E cambiado")" -->
            <ion-item>
              <ion-label> Departamento </ion-label>
              <ion-select id="error"  name="departamento" v-model="datos.departamento" ok-text="Aceptar" cancel-text="Cancelar">
                <ion-select-option value="Grafito"> Grafito </ion-select-option>
                <ion-select-option value="Formado"> Formado </ion-select-option>
                <ion-select-option value="Cocimiento"> Cocimiento </ion-select-option>
                <ion-select-option value="Ingenieria"> Ingenieria </ion-select-option>
                <ion-select-option value="Proyectos"> Proyectos </ion-select-option>
                
                <ion-select-option value="NaN"> No aplica</ion-select-option>
              </ion-select>
            </ion-item>

            <!-- Area de Maniobra -->
            <ion-item>
              <ion-label> Area de Maniobra </ion-label>
              <ion-select id="area_maniobra" name="AreaManiobra" v-model="datos.AreaManiobra" ok-text="Aceptar" cancel-text="Cancelar">
                <ion-select-option value="Empaque A"> Empaque A </ion-select-option>
                <ion-select-option value="Empaque B"> Empaque B </ion-select-option>
                <ion-select-option value="Empaque C"> Empaque C </ion-select-option>
                <ion-select-option value="Grafitacion"> Grafitacion </ion-select-option>
                <ion-select-option value="Taller Automotriz"> Taller Automotriz </ion-select-option>
                <ion-select-option value="Taller de Grafito"> Taller de Grafito </ion-select-option>
                <ion-select-option value="Almacengeneral"> Almacen general </ion-select-option>
                <ion-select-option value="Subestacion"> Subestacion </ion-select-option>
                <ion-select-option value="Embarques"> Embarques </ion-select-option>
                <ion-select-option value="Oficinas Admin"> Oficinas Admin </ion-select-option>
                <ion-select-option value="Area de Contratistas"> Area de Contratistas </ion-select-option>
                <ion-select-option value="Formado"> Formado </ion-select-option>
                <ion-select-option value="Hornos"> Hornos </ion-select-option>
                <ion-select-option value="Cilindros"> Cilindros </ion-select-option>

                <ion-select-option value="NaN"> No aplica</ion-select-option>
              </ion-select>
            </ion-item>

            <!-- Clasificación de Riesgo -->
            <ion-grid>
              <ion-row>
                <ion-segment class="full-width" color="tertiary" scrollable>
                  <ion-segment-button layout="icon-start" @click="alterBox()">
                    <ion-label >Peso</ion-label>
                    <ion-icon :src="require('../assets/svg/barbell-outline.svg')"></ion-icon>
                  </ion-segment-button>
                  <ion-segment-button @click="alterArrows()" layout="icon-start">
                    <ion-label>Altura</ion-label>
                    <ion-icon :src="require('../assets/svg/arrow-down-circle-outline.svg') "></ion-icon>
                  </ion-segment-button>
                  <ion-segment-button @click="alterRadio()" layout="icon-start">
                    <ion-label>Radio</ion-label>
                    <ion-icon :src="require('../assets/svg/radio-outline.svg')"></ion-icon>
                  </ion-segment-button>
                </ion-segment>
              </ion-row>

              <ion-row>
                <div class="background">
                  <div class="grua"></div>
                  <div class="rule-up"></div>
                  <div class="radio"></div>
                  <div class="rule-down"></div>
                  <div class="float-container"></div>
                </div>
              </ion-row>
            </ion-grid>
            <ion-item class="hidden">
              <ion-label position="floating">Peso de la carga</ion-label>
              <ion-input  name="peso"></ion-input>
            </ion-item>
            <ion-item class="hidden">
              <ion-label position="floating">Altura</ion-label>
              <ion-input  name="altura"></ion-input>
            </ion-item>
            <ion-item class="hidden">
              <ion-label position="floating">Radio </ion-label>
              <ion-input  name="radio"></ion-input>
            </ion-item>

            <ion-item>
              <ion-label position="floating"> Descripción de la maniobra </ion-label>
              <ion-textarea name="descripcion" v-model="datos.descripcion"></ion-textarea>
            </ion-item>
            
            <!-- Grúa -->
            <ion-item>
              <ion-label> Grúa </ion-label>
              <ion-select   :value="gruaTipo" @input="gruaTipo = $event.target.value" name="gruaTipo" ok-text="Okay" cancel-text="Cancelar">
                <ion-select-option v-for="u in unidades" :key="u.idd" :value="u.name" > {{ u.name }}</ion-select-option>
              </ion-select>
            </ion-item>            

            <!-- Tiempo de Maniobra -->
            <ion-list>
              <ion-radio-group  name="tiempoManiobra" v-model="datos.tiempoManiobra">
                <ion-list-header>
                  <ion-label >Tiempo de Maniobra</ion-label>
                </ion-list-header>
                
                <ion-item>
                  <ion-label> Menor a 4 Horas </ion-label>
                  <ion-radio slot="start" color="success" checked value="Menor a 4 Horas"></ion-radio>
                </ion-item>

                <ion-item>
                  <ion-label> de 4 horas a 6 horas </ion-label>
                  <ion-radio slot="start" color="success" value="de 4 horas a 6 horas" ></ion-radio>
                </ion-item>

                <ion-item>
                  <ion-label> de 6 horas a 8 horas </ion-label>
                  <ion-radio slot="start" color="success" value="de 6 horas a 8 horas"></ion-radio>
                </ion-item>

                <ion-item>
                  <ion-label> Otro </ion-label>
                  <ion-radio slot="start" color="success" value="Custoim"></ion-radio>
                </ion-item>


              </ion-radio-group>
            </ion-list>

            <!-- Fecha de Maniobra  -->
            <ion-item>
              <ion-label>Fecha de Maniobra</ion-label>
              <ion-datetime name="fecha" v-model="datos.fecha" :value="myDate" display-format="DD-MM-YYYY" placeholder="Select Date"></ion-datetime>
            </ion-item>
            <ion-item>
              <ion-label>Hora de Maniobra</ion-label>
              <ion-datetime name="hora" v-model="datos.hora" display-format="h:mm A" picker-format="h:mm A" :value="myDate"></ion-datetime>
            </ion-item>


            <!-- Responsable maniobra en el sitio  -->
            <ion-item>
              <ion-label position="floating">Responsable maniobra en el sitio</ion-label>
              <ion-input name="responsable" v-model="datos.responsable"></ion-input>
            </ion-item>
            <!-- Teléfono de Contacto -->
            <ion-item>
              <ion-label position="floating"> Teléfono de Contacto </ion-label>
              <ion-input name="contacto" v-model="datos.contacto"></ion-input>
            </ion-item>
          </ion-list>
        </form>
        <ion-grid>
          <ion-row>
            <ion-col class="ion-margin-top">
              <!-- <ion-button type="submit" @click="notifyHubSpot()" expand="full" > Solicitar Servicio  </ion-button> -->
              <ion-button type="submit" @click="showDataAlert()" expand="full" > Solicitar Servicio  </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-content>
	</div>
</template>

<script>
import axios from 'axios'
import firebase from '../config'
import {func} from '../func.js'
const { db } = firebase;
// import firebase from '../config'
// const { db } = firebase;
// import axios from 'axios';
import NavBar from '../components/NavBar.vue'

const allTodos = db.collection('todos')
export default {
  name: "newSolicitud",
  components: {NavBar},
  data() {
    return {
      gruaTipo:"indus-60_N4945",
      info: null,
      myDate: new Date().toISOString(),
      datos:[],
      userInfo:{},
      UserType:4,
      usrName:0,
      unidades:[]
    };
  },
  methods: {
    getUnidades(){
      let _self = this;
      let _unidades = [];
      db.collection('unidades')
      .where("activo","==", true)
      .orderBy('name')
      .get()
      .then(function(result) {
        result.forEach(function(doc) {
        //
        let tmp_data = doc.data(); 
        tmp_data.idd = doc.id;
        _unidades.push(tmp_data);
        });
        _self.unidades = _unidades;
      })
      .catch( err => console.log("Err get unidades => ",  err) )
    },
    reRedirect(stringROL){
      if(  stringROL == "1ib87WwHClPfwbCJS8BB") // Operaciones ROL
        this.UserType = 1; // this.$router.replace('/solicitudes') UserType
      else if( stringROL == "jcwXkDPT9SzhJJd179Sr") // USR GRAL ROL
        this.UserType = 2 // this.$router.replace('/solicitudes')
      else if( stringROL == "kBfoI8B7NUvsy33nA2VB") // USR ADMS
        this.UserType = 3; // this.$router.replace('/solicitudes-admin')
      else
        this.$router.replace("/login")
    },
    addTodo() {
      this.newTodo = '';
    },
    notifyHubSpot($d,$id){
      let uu = $d;
      uu.solicitud = $id;
      uu.pipeline = 4060129;
      uu.solicitud_num = func.returnID($id);
      uu.hora_string = func.getDateFormat($d.hora,"H");

      axios.post(`https://us-central1-mi-test-b974c.cloudfunctions.net/saveHubSpot`,uu)
      .then((result) => {
        console.log(result)
      }).catch((err) => {
        console.log(err)
      });
    },
    showDataAlert () {
      let __ = this;
      let _datos = {};
      let myForm = document.querySelector('form');
      for (let i = 0; i < myForm.length; i++) {
        if( myForm[i].value == ""  ){
          this.showAlert("El campo: "+ myForm[i].name + ", no puede estar vacío")
          return false; 
        }
        _datos[myForm[i].name] =  myForm[i].value;
        // _datos.push(x);
      }
      _datos.cliente = ( this.UserType != 1 ) ? this.userInfo.cliente: _datos.cliente;
      _datos.status = ["Enviada", 0];
      _datos.finsihHim = false;
      _datos.tiempoManiobra = document.querySelector("[name='tiempoManiobra']").value;
      _datos.created = new Date().toISOString();
      _datos.createdBy = this.userInfo.uuid;
      
      if (  window.localStorage.getItem('messagingToken') != null ){
        _datos.token =  window.localStorage.getItem('messagingToken');
      }
      
      _datos.revisionOP = false;
      allTodos.add(_datos)
      .then(function(docRef) {
        // console.log("Document written with ID: ", docRef.id);
        __.notifyHubSpot(_datos,docRef.id);
        _datos = {}
      })
      .catch(function(error) {
        console.error("Error adding document: ", error);
      });
      this.$router.push('solicitudes'); 
      // this.$storage.set("solicitudSinProcesar",_datos);
      // this.datos = _datos;
      // console.log($e);
    },
    showConsoleData () {
      // console.log(this.datos);
    },
    consoleMsg (){
      console.log("Err . . . .");
    },
    openStart () {
      document.querySelector('ion-menu-controller').open();
      document.querySelector('ion-menu').open('my-menu');
     console.log("Erroro"); 
    },
    // async getZipInfo(zip) {
    //   const res = await fetch(`https://api.zippopotam.us/us/${zip}`);
    //   if (res.status == 404) {
    //     this.showAlert();
    //   }
    //   this.info = await res.json();
    // },
    clearInfo() {
      this.info = null;
    },
    showAlert(msg) {
      return this.$ionic.alertController
        .create({
          header: "Acción requerida",
          message: msg,
          buttons: ["Aceptar"]
        })
        .then(a => a.present());
    },
    alterBox(){
      let container = document.querySelector(".float-container");
      container.classList.add("box");
      setTimeout( () => {
        container.classList.remove("box");
      },1000);
      document.querySelector('ion-input[name="peso"]').setFocus();
    },
    alterArrows(){
      let elArrowUp = document.querySelector(".rule-up");
      elArrowUp.classList.add("ampliar");
      let elArrowDown = document.querySelector(".rule-down");
      elArrowDown.classList.add("ampliar-down");
      setTimeout( () => {
        elArrowUp.classList.remove("ampliar");
        elArrowDown.classList.remove("ampliar-down");
      }, 1000)
      document.querySelector('ion-input[name="altura"]').setFocus();
    },
    alterRadio(){
      let elRadio = document.querySelector(".radio");
      elRadio.classList.add("show");
      setTimeout( () => {
        elRadio.classList.remove("show");
      }, 1000)
      document.querySelector('ion-input[name="radio"]').setFocus();
    }, 
    activeOnChange() {
      let _x = document.querySelectorAll("[type='hidden'].aux-input");
      for(let i=0; i < _x.length;i++) { 
        _x[i].addEventListener("change",(e)=>{ console.log("ha cambiado . . . .",e) });
        
      }
    },
    EstamosEn(){ 
      let vale = this.UserType;
        let _x = "none";
        switch (vale) {
          case 1:
            _x = "OP"
            break;
          case 2:
            _x = "USR"
            break;
          case 3:
            _x = "ADMS";
            break;
          default:
            break;
        }
        return _x;
      },
  },
  mounted () {
    
  },
  created () {
      let _self = this;
      let userInfo = this.$storage.get('user-info');
			if( userInfo != null ){
        this.userInfo = userInfo;
        _self.reRedirect(userInfo.rol);
				console.log("user info: ", userInfo)
      }
      _self.getUnidades();
    // this.activeOnChange();
    // console.log(this.$storage.get('solicitudSinProcesar'));
  }
};
</script>

<style >
  .background{
    height: 250px;
    width: 300px;
    position: relative;
    margin-left: 10%;
  }
  .grua{
    height:250px;
    width:300px;
    background:url("../assets/img/grua.png");
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .rule-up{
    position: absolute;
    height: 40px;
    width: 50px;
    top: 80px;
    background:url("../assets/img/arrow.gif");
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    right: -15px;
    transition: height .5s, top .5s;
  }
    .rule-up.ampliar{
      height: 60px;top:60px;
    }
  .rule-down{
    transition: height 1s, bottom 1s;
    position: absolute;
    height: 40px;
    width: 50px;
    bottom: 80px;
    transform:rotate(180deg);
    background:url("../assets/img/arrow.gif");
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    right: -15px;
  }
  .rule-down.ampliar-down{
    height: 60px;bottom:60px;
  }
  .radio{
    transition: width 1s, left 1s;
    z-index: -1;
    position: absolute;
    bottom: -1px;
    left: 20%;
    width: 220px;
    height: 30px;
    -webkit-filter: blur(4px);
    filter: blur(4px);
    border-radius: 50%;
    box-shadow: inset 0 0 50px #fff, inset 20px 0 40px #ffe200, inset -20px 0 20px #0ff, inset 20px 0 200px #ffe200, inset -20px 0 200px #0ff, 0 0 50px #fff;
    -webkit-box-shadow: inset 0 0 50px #fff, inset 20px 0 40px #5600ff, inset -20px 0 20px #4b00ff, inset 20px 0 200px #7a00ff, inset -20px 0 200px #3f00ff, 0 0 50px #fff;
  }
  .full-width{
    width: 100% !important;
  }
  .show{
    width: 320px;
    left: 5%;
    
  }
  .float-container{
    position: absolute;
    top: 105px;
    left: 3px;
    width: 70px;
    height: 60px;
    background: url("../assets/img/carga_box.png");
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    transition: top 1s ease, heigth 1s ease, width 1s ease;
    }
  .float-container.box{
    top:115px;
  }
</style>